import _ from 'underscore';

export default class OfferCampaignFields {
  constructor($scope, OfferCampaignService, UiService) {
    $scope.fields = [
      {
        name: 'general_text_en',
        description: 'General Text (English)'
      },
      {
        name: 'general_text_el',
        description: 'General Text (Greek)'
      },
      {
        name: 'general_text_el_per',
        description: 'General Text (Greek) (Personal)'
      },
      {
        name: 'matched_text_en',
        description: 'Matched Text (English)'
      },
      {
        name: 'matched_text_el',
        description: 'Matched Text (Greek)'
      },
      {
        name: 'matched_text_el_per',
        description: 'Matched Text (Greek) (Personal)'
      },
      {
        name: 'ospp_text_en',
        description: 'OSPP Text (English)'
      },
      {
        name: 'ospp_text_el',
        description: 'OSPP Text (Greek)'
      },
      {
        name: 'ospp_text_el_per',
        description: 'OSPP Text (Greek) (Personal)'
      },
      {
        name: 'pi_text_en',
        description: 'PI Text (English)'
      },
      {
        name: 'pi_text_el',
        description: 'PI Text (Greek)'
      },
      {
        name: 'pi_text_el_per',
        description: 'PI Text (Greek) (Personal)'
      },
      {
        name: 'matched_ospp_text_en',
        description: 'Matched + OSPP Text (English)'
      },
      {
        name: 'matched_ospp_text_el',
        description: 'Matched + OSPP Text (Greek)'
      },
      {
        name: 'matched_ospp_text_el_per',
        description: 'Matched + OSPP Text (Greek) (Personal)'
      },
      {
        name: 'matched_pi_text_en',
        description: 'Matched + PI Text (English)'
      },
      {
        name: 'matched_pi_text_el',
        description: 'Matched + PI Text (Greek)'
      },
      {
        name: 'matched_pi_text_el_per',
        description: 'Matched + PI Text (Greek) (Personal)'
      },
      {
        name: 'ospp_pi_text_en',
        description: 'OSPP + PI Text (English)'
      },
      {
        name: 'ospp_pi_text_el',
        description: 'OSPP + PI Text (Greek)'
      },
      {
        name: 'ospp_pi_text_el_per',
        description: 'OSPP + PI Text (Greek) (Personal)'
      },
      {
        name: 'matched_ospp_pi_text_en',
        description: 'Matched + OSPP + PI Text (English)'
      },
      {
        name: 'matched_ospp_pi_text_el',
        description: 'Matched + OSPP + PI Text (Greek)'
      },
      {
        name: 'matched_ospp_pi_text_el_per',
        description: 'Matched + OSPP + PI Text (Greek) (Personal)'
      },
      {
        name: 'embedded_offer_text_en',
        description: 'Recipient + Embedded Offer Text (English)'
      },
      {
        name: 'embedded_offer_text_el',
        description: 'Recipient + Embedded Offer Text (Greek)'
      },
      {
        name: 'embedded_offer_text_el_per',
        description: 'Recipient + Embedded Offer Text (Greek) (Personal)'
      },
      {
        name: 'pi_embedded_pi_text_en',
        description: 'PI Recipient + Embedded PI Text (English)'
      },
      {
        name: 'pi_embedded_pi_text_el',
        description: 'PI Recipient + Embedded PI Text (Greek)'
      },
      {
        name: 'pi_embedded_pi_text_el_per',
        description: 'PI Recipient + Embedded PI Text (Greek) (Personal)'
      },
      {
        name: 'pi_embedded_offer_text_en',
        description: 'PI Recipient + Embedded Offer Text (English)'
      },
      {
        name: 'pi_embedded_offer_text_el',
        description: 'PI Recipient + Embedded Offer Text (Greek)'
      },
      {
        name: 'pi_embedded_offer_text_el_per',
        description: 'PI Recipient + Embedded Offer Text (Greek) (Personal)'
      },
      {
        name: 'pi_embedded_pi_ignored_xls_text_en',
        description: 'PI Recipient + Embedded PI + Ignored XLS Text (English)'
      },
      {
        name: 'pi_embedded_pi_ignored_xls_text_el',
        description: 'PI Recipient + Embedded PI + Ignored XLS Text (Greek)'
      },
      {
        name: 'pi_embedded_pi_ignored_xls_text_el_per',
        description: 'PI Recipient + Embedded PI + Ignored XLS Text (Greek) (Personal)'
      },
      {
        name: 'pi_ignored_xls_text_en',
        description: 'PI Recipient + Ignored XLS Text (English)'
      },
      {
        name: 'pi_ignored_xls_text_el',
        description: 'PI Recipient + Ignored XLS Text (Greek)'
      },
      {
        name: 'pi_ignored_xls_text_el_per',
        description: 'PI Recipient + Ignored XLS Text (Greek) (Personal)'
      },
      {
        name: 'related_offer_en',
        description: 'Related Offer Text (English)'
      },
      {
        name: 'related_offer_el',
        description: 'Related Offer Text (Greek)'
      },
      {
        name: 'related_offer_el_per',
        description: 'Related Offer Text (Greek) (Personal)'
      }
    ];

    $scope.load_data = function() {
      $scope.loading = true;
      OfferCampaignService.get_fields().success(function(data) {
        _.each(data.fields, function(f) {
          var field = _.findWhere($scope.fields, {
            name: f.name
          });
          if (field) {
            field.id = f.id;
            field.value = f.value;
          }
        });
        $scope.loading = false;
      });
    };

    $scope.update_field = function(field) {
      field.updating = true;
      var field_data = {
        id: field.id || null,
        name: field.name,
        value: field.new_value
      };
      OfferCampaignService.update_field(field_data).success(function(data) {
        if (data.success) {
          if (data.field_id)
            field.id = data.field_id;
          field.value = field.new_value;
          field.edit_mode = false;
          field.updating = false;
        }
      });
    };

    $scope.init = function() {
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.load_data();
    };

    $scope.init();
  }
}

OfferCampaignFields.$inject = ['$scope', 'OfferCampaignService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-fields.ctrl.js